import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-bookings-stats',
  standalone: true,
  imports: [MaterialModule, NgApexchartsModule],
  templateUrl: './bookings-stats.component.html',
})
export class BookingsStatsComponent implements OnChanges {
  // { date: string, count: string | number }[]
  @Input() data: any[] = [];
  chartOptions: any = {};

  constructor() { this.buildChart(); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) this.buildChart();
  }

  private buildChart(): void {
    const dates = this.data.map(d => d.date);
    const counts = this.data.map(d => Number(d.count));

    this.chartOptions = {
      series: [{ name: 'Active Bookings', data: counts }],
      chart: { type: 'area', height: 250, toolbar: { show: false } },
      colors: ['#5e72e4'],
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth', width: 2 },
      fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 } },
      xaxis: { type: 'datetime', categories: dates, labels: { format: 'dd MMM' } },
      yaxis: { min: 0, labels: { formatter: (v: number) => Math.floor(v).toString() } },
      grid: { borderColor: '#f0f0f0', strokeDashArray: 4 },
      tooltip: { x: { format: 'dd MMM yyyy' } },
    };
  }
}
